var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex box"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/images/erro.svg")}}),_c('p',{staticClass:"grey--text"},[_vm._v(" 404 - Página não encontrada. ")]),_c('router-link',{attrs:{"to":{ name: 'mainUser' }}},[_vm._v(" Voltar para meu dados ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }